import * as React from "react";
import {Fragment} from "react";

class SideBarButton extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			show: false,
			hover: false
		}
		this.handleClick = this.handleClick.bind(this);
		this.handleHover = this.handleHover.bind(this);
	}

	handleClick() {
		if(this.props.onClick) {
			this.props.onClick();
		} else {
			this.setState(prevState => ({
				show: !prevState.show
			}));
		}
	}

	handleHover(hoverState) {
		this.setState({hover: hoverState});
	}

	render() {

		const {icon, label, children, id, handleAsCheckbox, position} = this.props;
		const {show, hover} = this.state;

		return (
			<Fragment>
				<div className="sidebar-button">
					{handleAsCheckbox &&
						<Fragment>
							<input type="checkbox" className="btn-check" id={`sbb${id}`} data-trigger={id} autoComplete="off" />
							<label className={`btn btn-outline-primary sidebar-toggle${show ? ` active` : ``}`} htmlFor={`sbb${id}`} onMouseOver={() => this.handleHover(true)} onMouseLeave={() => this.handleHover(false)} onClick={() => this.handleClick()} style={{lineHeight: '2.2rem'}} >
								<i className={icon} />
							</label>
						</Fragment>
					}
					{!handleAsCheckbox &&
						<button id={`sbb${id}`} data-trigger={id} type="button" className={`btn btn-outline-primary sidebar-toggle${show ? ` active` : ``}`} title={label} onMouseOver={() => this.handleHover(true)} onMouseLeave={() => this.handleHover(false)} onClick={() => this.handleClick()} >
							<i className={icon} />
						</button>
					}
					{label && hover &&
						<div className="button-label">
							{label}
						</div>
					}
					{show &&
						<Fragment>
							<div className={`sidebar-overlay${position ? ' ' + position : ''}`} >
								{children}
							</div>
							<div className="site-overlay" onClick={() => this.handleClick()} />
						</Fragment>
					}
				</div>
			</Fragment>
		);
	}
}

export default SideBarButton;
